import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/Store';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { Helmet } from 'react-helmet';
import BackToTopContainer from './common/components/BackToTop/BackToTopContainer';
import ScrollToTop from './common/components/ScrollToTop/ScrollToTop';
import DashboardContainer from './pages/Dashboard/DashboardContainer';
import Fleets from './pages/Fleets/Fleets';
import FleetsDetails from './pages/FleetsDetails/FleetsDetails';
import InstrumentDetailsContainer from './pages/InstrumentDetails/InstrumentDetailsContainer';
import AlertsConfiguration from './pages/AlertsConfiguration/AlertsConfiguration';
import SystemAlertsConfigurationPage from './pages/SystemAlertsConfiguration/SystemAlertsConfigurationPage';
import UsersManagement from './pages/UsersManagement/UsersManagement';
import Regions from './pages/Regions/Regions';
import RegionDetails from './pages/RegionDetails/RegionDetailsContainer';
import GroupDetails from './pages/GroupDetails/GroupDetailsContainer';
import Permissions from './pages/Permissions/Permissions';
import UserSettings from './pages/UserSettings/UserSettings';
import UserAuditLogs from './pages/UserAuditLogs/UserAuditLogs';
import SystemSettingsManagement from './pages/SystemSettings/SystemSettingsManagement';
import NotFound from './pages/NotFound/NotFound';
import FileManagementContainer from './pages/FileManagment/FileManagementContainer';
import UpdatePackagesContainer from './pages/UpdatePackages/UpdatePackages';
import ChatManagementContainer from './pages/ChatManagement/ChatManagementContainer';
import UpdateJobCreatorContainer from './pages/UpdateJobs/Components/UpdateJobCreatorContainer';
import UpdateJobContainer from './pages/UpdateJobs/Components/UpdateJobDetailsContainer';
import UpdateJobsMain from './pages/UpdateJobs/UpdateJobsMain';
import CommandJobCreatorContainer from './pages/CommandJobs/Components/CommandJobCreatorContainer';
import CommandJobContainer from './pages/CommandJobs/Components/CommandJobDetailsContainer';
import CommandJobsMain from './pages/CommandJobs/CommandJobsMain';
import SubscriptionManagement from './pages/SubscriptionManagement/SubscriptionManagement';
import ManufacturingDashboard from './pages/ManufacturingDashboard/ManufacturingDashboard';
import ManufacturingDashboardDetails from './pages/ManufacturingDashboardDetails/ManufacturingDashboardDetails';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { authRequest } from './common/constants/authConfig';
import { voTheme } from './common/constants/themeConfig';
import './index.css';
import Unauthorized from './pages/Unauthorized/Unauthorized';

function getTitle() {
  let host = window.location.hostname.split('.');
  if (Array.isArray(host)) {
    host = host[0];
  }
  let title = host.charAt(0).toUpperCase() + host.substring(1);
  return title;
}

const AppRoutes = (props) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={authRequest}
      >
        <Provider store={store}>
          <Helmet>
            <title>{getTitle()}</title>
          </Helmet>
          <ThemeProvider theme={voTheme}>
            <main>
              <ScrollToTop />
              <Routes>
                <Route exact path="/" element={<DashboardContainer />} />
                <Route exact path="/fleets" element={<Fleets />} />
                <Route exact path="/fleet-details/:id" element={<FleetsDetails />} />
                <Route exact path="/fleet-details/:id/:container" element={<FleetsDetails />} />
                <Route exact path="/edit-fleet/:id" element={<Fleets />} />
                <Route
                  exact
                  path="/instrument-details/:id"
                  element={<InstrumentDetailsContainer />}
                />
                <Route
                  exact
                  path="/instrument-details/:id/:container"
                  element={<InstrumentDetailsContainer />}
                />
                <Route exact path="/status-alert-configuration" element={<AlertsConfiguration />} />
                <Route
                  exact
                  path="/system-alert-configuration"
                  element={<SystemAlertsConfigurationPage />}
                />
                <Route exact path="/user-accounts" element={<UsersManagement />} />
                <Route exact path="/regions-and-groups/" element={<Regions />} />
                <Route exact path="/regions-and-groups/:id" element={<Regions />} />
                <Route exact path="/group-details/:id" element={<GroupDetails />} />
                <Route exact path="/permissions" element={<Permissions />} />
                <Route exact path="/user-settings" element={<UserSettings />} />
                <Route exact path="/user-audit-logs" element={<UserAuditLogs />} />
                <Route exact path="/system-settings" element={<SystemSettingsManagement />} />
                <Route exact path="/region-details/:id" element={<RegionDetails />} />
                <Route exact path="/file-management" element={<FileManagementContainer />} />
                <Route exact path="/chat-management" element={<ChatManagementContainer />} />
                <Route exact path="/update-packages" element={<UpdatePackagesContainer />} />
                <Route exact path="/#id_token" element={<DashboardContainer />} />
                <Route exact path="/null" element={<Navigate to="/" />} />
                <Route exact path="/update-job/:id" element={<UpdateJobContainer />} />
                <Route exact path="/update-jobs" element={<UpdateJobsMain />} />
                <Route exact path="/update-job-creator" element={<UpdateJobCreatorContainer />} />
                <Route exact path="/command-job/:id" element={<CommandJobContainer />} />
                <Route exact path="/command-jobs" element={<CommandJobsMain />} />
                <Route exact path="/command-job-creator" element={<CommandJobCreatorContainer />} />
                <Route exact path="/manufacturingDashboard" element={<ManufacturingDashboard />} />
                <Route
                  exact
                  path="/manufacturingDashboard-details/:id/"
                  element={<ManufacturingDashboardDetails />}
                />
                <Route exact path="/billing" element={<SubscriptionManagement />} />
                <Route exact path="/unauthorized" element={<Unauthorized asPage={true} />} />
                <Route path="*" element={<NotFound asPage={true} />} />
              </Routes>
              <BackToTopContainer />
            </main>
          </ThemeProvider>
        </Provider>
      </MsalAuthenticationTemplate>
    </LocalizationProvider>
  );
};

export default AppRoutes;
